export { SidebarSaleEntity } from './sidebar-sale';
